/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import Vue from 'vue';

/* ============
 * Plugins
 * ============
 *
 * Import and bootstrap the plugins.
 */

import './plugins/config';
import './plugins/vuex';
import './plugins/axios';
import i18n from './plugins/vue-i18n';
import { router } from './plugins/vue-router';
import './plugins/vuex-router-sync';
import './plugins/moment';
import './plugins/acronis-ui-kit';
import './assets/styles/index.scss';

/* ============
 * Global
 * ============
 *
 * Import components, directives, etc.
 */

import './directives';

/* ============
 * Main App
 * ============
 *
 * Import the main application.
 */

import App from './App';
import store from './store';

// Prevent message on console
Vue.config.productionTip = false;

// Init settings
store.dispatch('user/initializeAuth');
store.dispatch('setting');

/* eslint-disable no-new */
new Vue({
  /**
   * Bind the Vue instance to the HTML.
   */
  el: '#app',

  /**
   * The localization plugin.
   */
  i18n,

  /**
   * The router.
   */
  router,

  /**
   * The Vuex store.
   */
  store,

  /**
   * Will render the application.
   *
   * @param {Function} h Will create an element.
   */
  render: h => h(App),
});
